"use client";

import AuthForm from "./AuthForm";
import StoreBox from "../store/store-box";
import {
  setAccessPoint,
  setAccessPointId,
  setAccessPoints,
  setOrganisation,
} from "../slice/accessOrg-slice";
import { setActiveCategory, setCategories } from "../slice/category-slice";
import { useHistoryManager } from "../history/useHistoryManager";
import { useAppDispatch } from "../slice/hooks";
// import styles from "../store/index.module.css";
// import Image from "next/image";
// import { brandlogo } from "../../assets";
// import { useHistoryManager } from "../history/useHistoryManager";

const AuthPage = (props) => {
  const {
    activateBackButton,
    navLocation,
    // organisation,
    // accessPointId,
    // accessPoint,
    // accessPoints,
    // storePath,
  } = props;

  // const { navigateTo } = useHistoryManager();
  // const dispatch = useAppDispatch();
  return (
    <>
      <StoreBox {...props} handleLocationChange={() => {}}>
        <div className="auth-container">
          <AuthForm
            defaultLogin={true}
            onBack={null}
            activateBackButton={activateBackButton}
          />
        </div>
      </StoreBox>
    </>
  );
};

export default AuthPage;
